import { Component } from '@angular/core';
import {BoothPurchaseState, EventBooth} from "../../entities/booths/EventBooth";
import {APIService} from "../../services/APIService";
import {MatSnackBar} from "@angular/material/snack-bar";

@Component({
  selector: 'app-booth-list',
  templateUrl: './booth-list.component.html',
  styleUrls: ['./booth-list.component.css']
})
export class BoothListComponent {
  columns: string[] = ['org', 'type', 'owner', 'members', 'purchase_state', 'build_state'];

  filtered: EventBooth[] = [];
  datasource: EventBooth[] = [];

  constructor(private apiService: APIService, private snack: MatSnackBar) {
    this.apiService.getBooths().then((a) => {
      this.datasource = a;
      this.changeState("ALL");
    });
  }

  changeState(state: string) {
    let allowed: BoothPurchaseState | undefined = undefined;
    switch(state) {
      case "APPLIED":
        allowed = BoothPurchaseState.APPLIED;
        break;
      case "APPROVED":
        allowed = BoothPurchaseState.ACCEPTED;
        break;
      case "DENIED":
        allowed = BoothPurchaseState.REJECTED;
        break;
      default:
        break;
    }

    if(allowed === undefined)
      this.filtered = this.datasource;
    else
      this.filtered = this.datasource.filter((b) => b.purchaseState.state === allowed);
  }

  sendOpenedEmailAll() {
    if (!confirm('Send the "Booth Opened" email to ALL approved booths?')) return;
    this.apiService.sendGlobalBoothEmail('booth_accepted_opened')
      .then((r) => this.snack.open(`Sent to ${r.sent} recipients`))
      .catch(() => this.snack.open('Failed to send emails'))
  }
}
